export default __webpack_public_path__ + "static/media/card3.bce4110c.svg";